import { Injectable } from '@angular/core';
import { HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { AuthService } from './apis/usuario-admin/auth.service';

@Injectable({
  providedIn: 'root',
})
export class CommonService {
  constructor() {}
  private authService: AuthService;

  // Manipulação de erros
  // eslint-ignore
  handleError(error: HttpErrorResponse): Observable<never> {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // Erro ocorreu no lado do client
      errorMessage = error.error.message;
    } else {
      // Erro ocorreu no lado do servidor
      errorMessage = `Código do erro: ${error.status}, ` + `mensagem: ${error.message}`;

      if (error.status === 401) {
        //Desloga usuário
        this.authService.logout();
      }
    }
    return throwError(() => new Error(errorMessage));
  }

  // Adiciona tanto o Content-Type quanto o token no header
  addHeaderToken(): { headers: HttpHeaders } {
    const token: string = JSON.parse(sessionStorage.getItem('token') + '').token;

    const headerDict = {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      'Access-Control-Allow-Headers': 'Content-Type',
      Authorization: `Bearer ${token}`,
      'Authorization-Type': 'JwtAdminAuthorization',
    };

    const requestOptions = {
      headers: new HttpHeaders(headerDict),
    };

    return requestOptions;
  }

  // Adiciona somente o token no header
  addToken(): { headers: HttpHeaders } {
    const token: string = JSON.parse(sessionStorage.getItem('token') + '').token;

    const headerDict = {
      Authorization: `Bearer ${token}`,
      'Authorization-Type': 'JwtAdminAuthorization',
    };

    const requestOptions = {
      headers: new HttpHeaders(headerDict),
    };

    return requestOptions;
  }

  addHeaderFileToken(): { headers: HttpHeaders } {
    const token: string = JSON.parse(sessionStorage.getItem('token') + '').token;

    const headerDict = {
      // 'Content-Type': 'multipart/form-data',
      Accept: 'application/json',
      'Access-Control-Allow-Headers': 'Content-Type',
      Authorization: `Bearer ${token}`,
      'Authorization-Type': 'JwtAdminAuthorization',
    };

    const requestOptions = {
      headers: new HttpHeaders(headerDict),
    };

    return requestOptions;
  }
}
